import DataGrid from 'components/DataGrid';
import { useAccountingFund } from '../../hooks/useAccountingFund';
import { BtnClear, BtnSearch } from 'components/Button/ButtonAll';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import { useState } from 'react';
import { FormProvider } from 'react-hook-form';
import { I18n } from 'utilities/utilities';
import { Grid } from '@mui/material';
import { MultipleSelectItem } from 'components/Input/Select/MultipleSelectItem';

const AccountingFundList = () => {

    //#region Hook
    const {
        formSearch,
        dataColumn,
        getTable,
        onDelete,
        handleClearSearch,
        dataRow,
        loadingTable,
        lstStatus,
        lstMuseum
    } = useAccountingFund()
    // #endregion
    const [startDate, setStartDate] = useState(null);

    return (
        <Grid container spacing={1} justifyContent={'flex-start'}>
            <Grid item xs={12} >
                <FormProvider {...formSearch}>
                    <Grid container spacing={2} justifyContent={"flex-end"} alignItems={"start"}>
                        <Grid item xs={12} sm={4} md={3.5}>
                            <MultipleSelectItem
                                id={"arrMuseum"}
                                name={"arrMuseum"}
                                label={`พิพิธภัณฑ์`}
                                required={false}
                                options={lstMuseum}
                                limitTag={1}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3} md={2.5}>
                            <DatePickerItem
                                id={`nStartDate`}
                                name={`nStartDate`}
                                label={`วันที่นำฝาก (เริ่มต้น)`}
                                fullWidth
                                onChange={(e) => {
                                    setStartDate(e);
                                    if (e) {
                                        formSearch.setValue("sDateEnd", null);
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3} md={2.5}>
                            <DatePickerItem
                                id={`nEndDate`}
                                name={`nEndDate`}
                                label={`วันที่นำฝาก (สิ้นสุด)`}
                                minDate={startDate}
                                fullWidth
                                disabled={false}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2.5} >
                            <MultipleSelectItem
                                id={"arrStatusId"}
                                name={"arrStatusId"}
                                label={`${I18n.SetText("Ticket.Status")}`}
                                required={false}
                                options={lstStatus}
                            />
                        </Grid>
                        <Grid item xs={12} md={'auto'}>
                            <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center" >
                                <Grid item>
                                    <BtnClear id={"btn-clear"} IsCircleWithOutText onClick={() => handleClearSearch()} />
                                </Grid>
                                <Grid item>
                                    <BtnSearch id={"btn-search"} IsCircleWithOutText onClick={() => getTable(dataRow)} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </FormProvider>
            </Grid>
            <Grid item xs={12} >
                <DataGrid
                    columns={dataColumn}
                    isShowCheckBox={false}
                    rows={dataRow}
                    isLoading={loadingTable}
                    onLoadData={getTable}
                    isHiddenFooter={dataRow.arrRows.length === 0}
                    onDelete={onDelete}
                    sTableID='gtAccpayment'
                    isHiddenToolHead={true}
                // filterField={filterListTicket}
                />
            </Grid>
        </Grid>

    )
}

export default AccountingFundList
